module.exports = __webpack_public_path__ + "01_mole.889a4b1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer2/01_mole.png
// module id = DUIH
// module chunks = 0